<template>
    <DModal
        :title="title"
        :show="showModal"
        is-confirm
        @close="$emit('close-modal')"
        @confirm="saveUser"
    >
        <DCard
            padding
        >
            <DFormRow
                :label="$t('users.field_assign_role')"
                :is-required="true"
                :error="errors.role"
            >
                <DSelect
                    v-model="form.role"
                    :placeholder="$t('users.role_select_placeholder')"
                    :options="roles"
                    :is-valid="errors.role ? false : null"
                />
            </DFormRow>
        </DCard>
    </DModal>
</template>

<script>
import { router, useForm } from '@inertiajs/vue3'

export default {
    name: 'UserEditModal',
    props: {
        user: {
            type: Object,
            default: () => { return {} }
        },
        roles: {
            type: Array,
            default: () => { return [] }
        },
        errors: {
            type: Object,
            default () {
                return {}
            }
        },
        showModal: {
            type: Boolean,
            default: true
        }
    },
    emits: ['close-modal'],
    data () {
        return {
            form: useForm({
                role: this.user.roles !== undefined ? this.user.roles[0].id : null
            })
        }
    },
    computed: {
        title () {
            return this.$t('users.edit_role_title', { name: this.user.name })
        }
    },
    methods: {
        saveUser () {
            router.put(this.$route('users.update', { user: this.user.id }), this.form)
        }
    }
}
</script>
